import api from './HttpService';
import { AUDIT_TRAIL } from '../configs/ApiActionUrl';

async function getAll(pageOption, type, date, rangeDate, user, module, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&per_page=${pageSize}`;
    }
  }

  if (type) {
    query += `&event_type=${type}`;
  }

  if (date) {
    query += `&date=${date}`;
  }

  if (user) {
    query += `&user_id=${user}`;
  }
  if (module) {
    query += `&module_name=${module}`;
  }
  if (rangeDate) {
    const { dateStart, dateEnd } = rangeDate;
    if (dateStart && dateEnd) {
      query += `&start_date=${dateStart}&end_date=${dateEnd}`;
    }
  }

  // if (sortData) {
  //   const { sortField, sort } = sortData;
  //   if (sortField && sort) {
  //     query += `&sort_by=${sortField}&order_by=${sort}`;
  //   }
  // }

  if (keyword) {
    query += `&unique_id=${keyword}`;
  }

  try {
    const res = await api.get(AUDIT_TRAIL.LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function getItem(code) {
  const res = await api.get(`${AUDIT_TRAIL.GET_ITEM}/${code}`);
  return res;
}

async function getFilterModule() {
  const res = await api.get(`${AUDIT_TRAIL.GET_MODULE}`);
  return res;
}

async function getFilterUser() {
  const res = await api.get(`${AUDIT_TRAIL.GET_USER}`);
  return res;
}
const AuditService = {
  getAll,
  getItem,
  getFilterUser,
  getFilterModule
};

export default AuditService;
